import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadMaCisDetailsCreator,
} from '../../../../../store/actionsCreators';
import ViewChangeRequest from '../../../../../shared/ChangeRequest/View/ViewChangeRequest';

const mapStateToProps = ({ loading, ma, user }) => ({
  loading: isLoading(loading, 'LOAD_MA_CIS_DETAILS'),
  profile: ma.cis.changeRequests.profile,
  userPermissions: user.userPermissions,
  type: 'ma',
});

const mapDispatchToProps = (dispatch) => ({
  loadDetails: (id, history) => dispatch(loadMaCisDetailsCreator('changeRequests', id, history)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewChangeRequest);
